import React from 'react';
import LogoutContainer from 'containers/LogoutContainer';


class LogoutPage extends React.Component {
	render() {
		return (
				<LogoutContainer history={this.props.history} />
			);
		
	}
}


export default LogoutPage;


// WEBPACK FOOTER //
// ./src/pages/LogoutPage.js